import { Box, Button, Modal, Slide, SxProps } from '@mui/material';
import { ReactNode } from 'react';
import {
  IconWrapper,
  ImageWrapper,
  IStyles,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';

interface IProps {
  open: boolean;
  iconName: string;
  handleClose: () => void;
  popupBody: ReactNode;
  closeIcon?: boolean;
  popupStyle?: SxProps;
}
export const HalfCirclePopupBase = (props: IProps) => {
  const { open, iconName, handleClose, popupBody, closeIcon, popupStyle } =
    props;

  // -------------------------------------------------------------

  const styles: IStyles = {
    root: {},
    popupBase: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
    },
    popupContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: { xs: pxToRem(80), md: pxTovW(20) },
      flexDirection: { xs: 'column-reverse', md: 'row' },
      alignItems: { xs: 'center', md: 'flex-start' },
      width: { xs: '95%', md: 'unset' },
    },
    popupContent: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      width: { xs: '95%', md: pxTovW(800), lg: pxTovW(670) },
      borderRadius: { xs: pxToRem(20), md: pxTovW(20) },
      ...popupStyle,
    },
    popupContentIcon: {
      position: 'relative',
      top: '0px',
      left: '0%',
      height: pxTovW(8),
      width: '100%',
    },
  };

  // -------------------------------------------------------------

  return (
    <Modal open={open} onClose={handleClose}>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={500}>
        <Box sx={styles.popupBase}>
          <Box sx={styles.popupContainer}>
            <Box sx={styles.popupContent}>
              <Box sx={styles.popupContentIcon}>
                <IconBox iconName={iconName} />
              </Box>

              {popupBody}
            </Box>

            {closeIcon && (
              <Button onClick={handleClose} sx={{ p: '0px' }}>
                <IconWrapper
                  name="close-yellow"
                  size="md"
                  parentFolder="icons"
                  type="png"
                  customSx={{
                    width: { xs: pxToRem(33), md: pxTovW(50) },
                    height: { xs: pxToRem(33), md: pxTovW(50) },
                  }}
                />
              </Button>
            )}
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};

// -------------------------------------------------------------

interface IConProps {
  iconName: string;
}
const IconBox = (props: IConProps) => {
  const { iconName } = props;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          height: { xs: pxToRem(113), md: pxTovW(143) },
          display: 'flex',
          width: { xs: pxToRem(113), md: pxTovW(143) },
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          boxSizing: 'border-box',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          transform: 'translateY(-50%)',
        }}
      >
        <ImageWrapper
          name={iconName}
          parentFolder="icons"
          type="png"
          styles={{
            height: { xs: pxToRem(52), md: pxTovW(100) },
            width: { xs: pxToRem(52), md: pxTovW(100) },
          }}
        />
      </Box>
    </Box>
  );
};

// -------------------------------------------------------------
